import { api } from "data";
import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";

export const useEditBookingQuestions = () => {
  return useCustomMutation({
    url: api.questions.update_questions,
    onMutate: () => null,
    onSettled: () => null,
    onSuccess: () => null,
  });
};
